import apiSales from '../apiSales';

import { ParamsBodyPostCreateQuote, ParamsDataPostCreateQuote } from 'utils/typeServices';

type response = {
    IsSuccess: boolean;
    Messages: Array<{
        CodeLevel: number;
        Description: string;
    }>;
    Data: ParamsDataPostCreateQuote;
}

export const PostCreateQuote = async (body: ParamsBodyPostCreateQuote) => {
    const bodyJson = body;
    const token = localStorage.getItem('token');

    try {
        const { data } = await apiSales.post<response>('/quote/v3', bodyJson, {
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

        return data;
    } catch (error) {
        console.error('error', error);
        return null;
    }
}
